export default __webpack_public_path__ + "static/media/jackpot-ms.bf78c1dc.webp";